import * as XLSX from 'xlsx';
import sortBy from 'lodash/sortBy';
import client from './apollo-client';
import gql from 'graphql-tag';

const ADMIN_EXPORT_QUERY = gql`
	query adminQuery($sessionID: ID!){
		user {
			id
			session ( sessionID: $sessionID ){
				id
				name
				games {
					id
					data
				}
			}
		}
	}
`;

export default function exportResults(sessionID) {
	client.query({
	  query: ADMIN_EXPORT_QUERY,
		variables:{ sessionID }
	}).then(({data}) => {
		const session = data.user.session;
		const leaderGames = session.games.filter(game => game.data.leader === true);
		const new_workbook = XLSX.utils.book_new();
		const pages = leaderGames.map(game => generatePageFromGame(game));
		pages.forEach((page, index) => {
			const worksheet = XLSX.utils.aoa_to_sheet(page);
			XLSX.utils.book_append_sheet(
				new_workbook,
				worksheet,
				leaderGames[index].data.name.substr(0,30) + '\u2026'
			);
		});
		XLSX.writeFile(new_workbook, `session-${session.name}.xlsx`);
	})
}
function getYearsValues(variableName) {
	return sortBy(
		this.businessPlan.variables.filter(
			variable => variable.name === variableName
		),
		['year']
	).map(v => v.value);
}
function getBottleValue() {
	const variable = this.businessPlan.variables.find(
		variable => variable.name === 'supplierBottleChoice'
	);
	switch (variable.value) {
	case 1:
		return 'standard';
	case 2:
		return 'customized';
	case 3:
		return 'premium';
	default:
		console.log('can not find relative bottle name!!');
	}
}
function getAppleValue() {
	const variable = this.businessPlan.variables.find(
		variable => variable.name === 'supplierAppleChoice'
	);
	switch (variable.value) {
	case 1:
		return 'mellino';
	case 2:
		return 'tafaha';
	case 3:
		return 'manzanita';
	default:
		console.log('can not find relative apple name!!');
	}
}
function getNumberValue(variableName) {
	const variable = this.businessPlan.variables.find(
		variable => variable.name === variableName
	);
	return variable.value;
}

function generatePageFromGame(game) {
	const page = [];
	const businessPlan = game.data.businessPlans.find(
		bs => bs.submission === game.data.lastSubmission
	);
	const $Array = getYearsValues.bind({ businessPlan });
	const $Number = getNumberValue.bind({ businessPlan });
	const $Bottle = getBottleValue.bind({ businessPlan });
	const $Apple = getAppleValue.bind({ businessPlan });
	page.push(
		['Coordinator', game.data.name],
		['Team', game.data.team],
		['Hearts', game.data.hearts],
		['Money', game.data.money],
		['Final Submission', game.data.lastSubmission],
		['Final Decision', game.data.cashDecisions],
		[],
		[],
		['Decisions throughout the years', 'Year 1', 'Year 2', 'Year 3'],
		[],
		['Price', ...$Array('price')],
		['Days in receivables', ...$Array('daysReceivable')],
		['Bottle model', $Bottle()],
		['Production lines', $Number('machines')],
		['Production capacity %', ...$Array('machineProductionCapacityUsageQuota')],
		['Outsourcing %', ...$Array('outsourcingQuota')],
		['Quality (stars)', ...$Array('quality')],
		['Quality (experts)', ...$Array('quality')],
		['Apple supplier', $Apple()],
		[],
		[],
		['Income Statement', 'Year 1', 'Year 2', 'Year 3'],
		[],
		['Revenues', ...$Array('revenues')],
		['- Direct material costs', ...$Array('directMaterialCosts')],
		[
			'- Total outsourced production costs',
			...$Array('outsourcedProductionCosts')
		],
		['- Selling commissions', ...$Array('sellingCommissions')],
		['Contribution margin', ...$Array('contributionMargin')],
		['- Production overheads', ...$Array('productionOverheads')],
		['- Marketing expenses', ...$Array('marketingExpenses')],
		['- Selling expenses', ...$Array('sellingExpenses')],
		[
			'- General and administrative expenses',
			...$Array('generalAndAdministrativeExpenses')
		],
		['Operating income (EBIT)', ...$Array('operatingIncome')],
		[
			'- Interest expenses on long-term debts',
			...$Array('interestExpensesLongTerm')
		],
		[
			'- Interest expenses on short-term debts (line of credit)',
			...$Array('interesetExpensesOnBankOverdraft')
		],
		['Pre-tax income', ...$Array('preTaxIncomeWithShortTerm')],
		['Taxes', ...$Array('taxes')],
		['Net income', ...$Array('netIncome')],
		[],
		[],
		['Balance Sheet', 'Year 1', 'Year 2', 'Year 3'],
		[],
		['Cash', ...$Array('cash')],
		['Account receivables', ...$Array('accountReceivables')],
		['Raw material inventory', ...$Array('totalRawMaterialInventory')],
		['Finished goods inventory', ...$Array('finishedGoodsInventory')],
		['Total current assets', ...$Array('totalCurrentAssets')],
		['Net fixed assets', ...$Array('netFixedAssets')],
		['Total assets', ...$Array('totalAssets')],
		['Account payables (total)', ...$Array('accountPayables')],
		['Short-term debt', ...$Array('shortTermDebts')],
		['Current liabilities', ...$Array('currentLiabilities')],
		['Long-term debt', ...$Array('longTermDebt')],
		['Total liabilities', ...$Array('totalLiabilities')],
		["Common stockholders' equity", ...$Array('equity')],
		['Reserves (Retained earnings)', ...$Array('retainedEarnings')],
		['Net income', ...$Array('netIncome')],
		['Total equity', ...$Array('totalEquity')],
		['Total liabilities and equity', ...$Array('totalLiabilitiesAndEquity')],
		[],
		[],
		['Cash Flow Statement', 'Year 1', 'Year 2', 'Year 3'],
		[],
		['Net income', ...$Array('netIncome')],
		['Depreciation (total)', ...$Array('fixedAssetsDepreciation')],
		['+ Δ inventory', ...$Array('inventoryDelta')],
		['+ Δ receivables', ...$Array('receivablesDelta')],
		['- Δ payables', ...$Array('payablesDelta')],
		['Cash flow from operations (CFO)', ...$Array('cashFlowFromOperations')],
		['- CAPEX', ...$Array('capitalExpenditures')],
		['+ Long-term debt', ...$Array('longTermDebtDelta')],
		['+ Short-term debt', ...$Array('shortTermDebtsDelta')],
		["+ Common stockholders' equity", ...$Array('equityDelta')],
		['Total cash', ...$Array('totalCashFlow')],
		[],
		[],
		['KPIs', 'Year 1', 'Year 2', 'Year 3'],
		[],
		['Revenues', ...$Array('revenues')],
		['Operating Income (EBIT)', ...$Array('operatingIncome')],
		['CCC/Sales', ...$Array('cccSales')],
		['Cash', ...$Array('cash')],
		['Leverage', ...$Array('leverage')],
		['ROE', ...$Array('roe')],
		['ROA', ...$Array('roa')]
	);
	return page;
}
